export default __webpack_public_path__ + "static/media/loading.8b4a0429.gif";